import { FrameBuffer,  Container, Mesh, Program, Texture, BoxGeometryBuffer, PlaneGeometryBuffer} from 'beam';

import boxVertexShader from './shaders/box-vs.glsl'
import boxFragmentShader from './shaders/box-fs.glsl'
import blurVertexShader from './shaders/blur-vs.glsl'
import blurFragmentShader from './shaders/blur-fs.glsl'

const USE_RT = false;

const BLUR_RES = 1024;

const REFLECTION_ALTAS_W = 256;
const REFLECTION_ATLAS_H = 256;
const VIDEO_FPS = 50;
const USE_MIPMAP = true;

let sharedBlurProgram;
let sharedBoxProgram;
let sharedBoxGeometry;
let sharedPlaneGeometry;


function fit(contains) {
    return (parentWidth, parentHeight, childWidth, childHeight, scale = 1, offsetX = 0.5, offsetY = 0.5) => {
      const childRatio = childWidth / childHeight
      const parentRatio = parentWidth / parentHeight
      let width = parentWidth * scale
      let height = parentHeight * scale
  
      if (contains ? (childRatio > parentRatio) : (childRatio < parentRatio)) {
        height = width / childRatio
      } else {
        width = height * childRatio
      }
  
      return {
        width,
        height,
        offsetX: (parentWidth - width) * offsetX,
        offsetY: (parentHeight - height) * offsetY
      }
    }
  }
  
const contain = fit(true)
const cover = fit(false)

const DEBUG_MIPMAP = false;
let debugMipmapValue = -1;
// if (DEBUG_MIPMAP) {
//     const GUI = document.createElement('input');
//     GUI.setAttribute('min', -1)
//     GUI.setAttribute('max', 8)
//     GUI.setAttribute('value', -1)
//     GUI.setAttribute('step', 1)
//     GUI.setAttribute('type', 'range')
//     GUI.addEventListener('change', e => {
//         debugMipmapValue = Number(GUI.value);
//     })
//     GUI.addEventListener('mousemove', function(e) {
//         debugMipmapValue = Math.round( Math.min(1, Math.max(0, e.offsetX / e.target.clientWidth)) *  parseInt(e.target.getAttribute('max'),10));
//     });
//     GUI.value = -1;
//     GUI.style.position = "fixed";
//     GUI.style.top = 0;
//     GUI.style.top = 0;
//     GUI.style.zIndex = 99999999;
//     GUI.style.background = 'red';
//     document.body.appendChild(GUI);
// }   


export default class Box {

    constructor(renderer, options) {
        
        const container = new Container();

        this.renderer = renderer;

        this.frameIndex = 0;
        this.resolution = [window.innerWidth, window.innerHeight];
        this.boxScale   = options.scale || 1;
        this.boxOffsetY = 0;
        this.rendferedBluredFrame = 0;

        this.fitViewport = options.fitViewport
        this.skipPortraitScale = options.skipPortraitScale || false

        this.boxDepth = 50;//this.skipPortraitScale && window.innerWidth < 600 ? 25 :   50;

        this.maskChanel = options.maskChanel;

        sharedBlurProgram = sharedBlurProgram || new Program(this.renderer.gl, {
            blend:          false,
            vertexShader:   blurVertexShader,
            fragmentShader: blurFragmentShader,
        });;

        this.blurMaterial = sharedBlurProgram;

        if (/(mp4|webm)$/.test(options.src)) {
            this.screenTexture = new Texture(this.renderer.gl, {
                linear:    true,
                mipmap:    false,
                miplinear: false,
            });
            this.video = document.createElement('video');
            this.video.width  = 1562
            this.video.height = 934
            this.video.autoplay = true;
            this.video.muted = true;
            this.video.loop = true;
            this.video.playsinline = true;
            this.video.setAttribute('muted', 'true');
            this.video.setAttribute('playsinline', 'true');
            this.video.setAttribute('loop', 'true');
            this.video.setAttribute('autoplay', 'true');
            this.video.setAttribute('preload', 'true');
            this.onVideoPlay = this.onVideoPlay.bind(this);
            this.onVideoPause = this.onVideoPause.bind(this);
            this.video.addEventListener('play',  this.onVideoPlay);
            this.video.addEventListener('pause', this.onVideoPause);
            this.video.src = options.src;
            if (this.fitViewport) {
                this.canvas        = document.createElement('canvas');
                this.canvas.width  = window.innerWidth
                this.canvas.height = window.innerHeight
                this.ctx = this.canvas.getContext('2d');
                const { offsetX,  offsetY,  width,  height} = cover(window.innerWidth, window.innerHeight, this.video.width, this.video.height);
                this.ctx.drawImage(this.video, offsetX, offsetY, width, height);
                this.screenTexture.loaded = true;
                this.screenTexture.bindImage(this.canvas);
            }
        }
        else if (options.fitViewport) {
            this.screenTexture = new Texture(this.renderer.gl, {
                linear:    true,
                mipmap:    false,
                miplinear: false,
            });
            this.canvas        = document.createElement('canvas');
            this.canvas.width  = window.innerWidth
            this.canvas.height = window.innerHeight
            this.ctx = this.canvas.getContext('2d');
            this.ctx.fillStyle = '#ff0000';
            this.ctx.fillRect(0,0,this.canvas.width, this.canvas.height);
            this.img = new Image();
            this.img.onload = ()=> {
                const { offsetX,  offsetY,  width,  height} = cover(window.innerWidth, window.innerHeight, this.img.width, this.img.height);
                this.ctx.drawImage(this.img, offsetX, offsetY, width, height);
                this.screenTexture.loaded = true;
                this.screenTexture.bindImage(this.canvas);
            }
            this.img.src = options.src;
        }
        else {
            this.screenTexture = Texture.fromUrl(this.renderer.gl,options.src);
        }


        if (!USE_RT) {
            
            this.blurTexture0 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES,       height: BLUR_RES          , linear: true });
            
            this.blurTextureTemp1 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?2:1),   height: BLUR_RES  /   (USE_MIPMAP?2:1)  , linear: true });
            this.blurTextureTemp2 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?4:1),   height: BLUR_RES  /   (USE_MIPMAP?4:1)  , linear: true });
            this.blurTextureTemp3 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?8:1),   height: BLUR_RES  /   (USE_MIPMAP?8:1)  , linear: true });
            this.blurTextureTemp4 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?16:1),  height: BLUR_RES  /   (USE_MIPMAP?16:1) , linear: true });
            this.blurTextureTemp5 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?32:1),  height: BLUR_RES  /   (USE_MIPMAP?32:1) , linear: true });
            this.blurTextureTemp6 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?64:1),  height: BLUR_RES  /   (USE_MIPMAP?64:1) , linear: true });
            this.blurTextureTemp7 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?128:1),  height: BLUR_RES /   (USE_MIPMAP?128:1), linear: true });
            this.blurTextureTemp8 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?256:1),  height: BLUR_RES /   (USE_MIPMAP?256:1), linear: true });
            this.blurTextureTemp9 = new FrameBuffer(this.renderer.gl,  { width:  BLUR_RES / (USE_MIPMAP?512:1),  height: BLUR_RES /   (USE_MIPMAP?512:1), linear: true });
            this.blurTextureTemp10 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?1024:1),  height: BLUR_RES /   (USE_MIPMAP?1024:1), linear: true });
            
            this.blurTexture1 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?2:1),   height: BLUR_RES  /  (USE_MIPMAP?2:1)       , linear: true });
            this.blurTexture2 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?4:1),   height: BLUR_RES  /  (USE_MIPMAP?4:1)       , linear: true });
            this.blurTexture3 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?8:1),   height: BLUR_RES  /  (USE_MIPMAP?8:1)       , linear: true });
            this.blurTexture4 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?16:1),  height: BLUR_RES  /  (USE_MIPMAP?16:1)      , linear: true });
            this.blurTexture5 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?32:1),  height: BLUR_RES  /  (USE_MIPMAP?32:1)      , linear: true });
            this.blurTexture6 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?64:1),  height: BLUR_RES  /  (USE_MIPMAP?64:1)      , linear: true });
            this.blurTexture7 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?128:1),  height: BLUR_RES /  (USE_MIPMAP?128:1)     , linear: true });
            this.blurTexture8 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?256:1),  height: BLUR_RES /  (USE_MIPMAP?256:1)     , linear: true });
            this.blurTexture9 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?512:1),  height: BLUR_RES /  (USE_MIPMAP?512:1)     , linear: true });
            this.blurTexture10 = new FrameBuffer(this.renderer.gl, { width:  BLUR_RES / (USE_MIPMAP?1024:1),  height: BLUR_RES /  (USE_MIPMAP?1024:1)     , linear: true });
       
        }
        else {
            this.reflectionAtlasRead = new FrameBuffer(this.renderer.gl, { width:  REFLECTION_ALTAS_W,       height: REFLECTION_ATLAS_H ,        linear: true });
            this.reflectionAtlasWrite = new FrameBuffer(this.renderer.gl, { width:  REFLECTION_ALTAS_W,       height: REFLECTION_ATLAS_H ,        linear: true });
        }

        const planes = [
            { index: 0, name: 'center', position: [0,0,-25], rotation: [0,0,0],        width: 1,           height: 1,            },
        ];          
        
        this.planes = [];
        
        sharedBoxProgram = sharedBoxProgram || new Program(this.renderer.gl, {
            vertexShader:   boxVertexShader,
            fragmentShader: boxFragmentShader,
        });

        sharedPlaneGeometry = sharedPlaneGeometry || new PlaneGeometryBuffer(this.renderer.gl, {
            width:  1,
            height: 1,
        });

        for (const plane of planes) {
            const planeMesh = new Mesh({
                beforeRender: ()=>{
                    planeMesh.material.setUniform('tBg', this.screenTexture);
                    planeMesh.material.setUniform('uMaskChanel', this.maskChanel);
                    planeMesh.material.setUniform('uPlaneIndex', plane.index);
                    for (let i=0; i<10; i++) {
                        planeMesh.material.setUniform('tMipMap'+ i, this['blurTexture'+i]);
                    }

                }
            });
            planeMesh.name = plane.name + 'Plane';
            planeMesh.geometry = sharedPlaneGeometry
            planeMesh.material = sharedBoxProgram
            planeMesh.rotation = plane.rotation;
            planeMesh.position = plane.position;
            planeMesh.updateMatrix()
            planeMesh.updateWorldMatrix()
            this[plane.name + 'PlaneMesh'] = planeMesh;
            this.planes.push(planeMesh);
            container.add(planeMesh);
        }

        this.boxMesh = new Mesh({
            beforeRender: ()=>{
                if ( USE_RT ) {
                    this.boxMesh.material.setUniform('tBg', this.boxMesh._isReflectionPass ? this.screenTexture : this.reflectionAtlasRead);
                }
                else {
                    this.boxMesh.material.setUniform('tBg', this.screenTexture);
                }
                
                this.boxMesh.material.setUniform('uScale', this.boxScale );
                this.boxMesh.material.setUniform('uRefMatrix', this.planes[0].worldMatrix);
                this.boxMesh.material.setUniform('uPlaneIndex', 1);
                this.boxMesh.material.setUniform('uMaskChanel', this.maskChanel);
                this.boxMesh.material.setUniform('tSource', this.screenTexture);
                if (this.boxMesh.material.beforeRenderUniforms) {
                    for (let k in this.boxMesh.material.beforeRenderUniforms) {
                        this.boxMesh.material.setUniform(k, this.boxMesh.material.beforeRenderUniforms[k]);
                    }
                }

                this.boxMesh.material.setUniform('uDebugMipmap', DEBUG_MIPMAP ? debugMipmapValue : -1);

                this.boxMesh.material.setUniform('uRefMatrix', this.planes[0].worldMatrix);

                this.boxMesh.material.setUniform('uSourceResolution',  this.screenTextureResolution);//[1562, 934]);
                this.boxMesh.material.setUniform('uFrameIndex', this.frameIndex);

                this.boxMesh.material.setUniform('uBoxDepth', this.boxDepth);

                

                this.boxMesh.material.setUniform('uPortraitScale2', this.skipPortraitScale ? 1 :  this.screenTexture.height > this.screenTexture.width ? 2 : 1);
                this.boxMesh.material.setUniform('uPortraitScale',  this.skipPortraitScale ? 1 :  this.screenTexture.height > this.screenTexture.width   ? 2 : 1);

            }
        });

        sharedBoxGeometry = sharedBoxGeometry || new BoxGeometryBuffer(this.renderer.gl, {
            width:  100, 
            height: 100, 
            depth:  this.boxDepth
        });

        /** TRIANGULATE */
        if (!sharedBoxGeometry.triangulated && USE_RT) {
            const geometry = sharedBoxGeometry;
            let indexedPositions = []
            let indexedNormals   = []
            let indexedUvs       = []
            let indexedColors    = []
            let _positions       = geometry.attributes.position.data
            let _normals         = geometry.attributes.normal.data
            let _colors          = geometry.attributes.color.data
            let _indices         = geometry.attributes.index.data
            let _uvs             = geometry.attributes.uv.data;
            for (let i=0; i<_indices.length; i++) {
                let vertexIndex = _indices[ i ];
                indexedPositions.push( _positions[vertexIndex*3+0], _positions[vertexIndex*3+1], _positions[vertexIndex*3+2] );
                indexedNormals.push(   _normals[vertexIndex*3+0],   _normals[vertexIndex*3+1],   _normals[vertexIndex*3+2]   );
                indexedColors.push(    _colors[vertexIndex*3+0],    _colors[vertexIndex*3+1],    _colors[vertexIndex*3+2]    );
                indexedUvs.push(       _uvs[vertexIndex*2+0],       _uvs[vertexIndex*2+1]                                    );
            }
            geometry.attributes.position.update( new Float32Array( indexedPositions ), 3 );
            geometry.attributes.color.update( new Float32Array( indexedColors ), 3 );
            geometry.attributes.normal.update( new Float32Array( indexedNormals ), 3 );
            geometry.attributes.uv.update( new Float32Array( indexedUvs ), 2 );
            geometry.length = indexedPositions.length / 3;
            delete geometry.attributes.index;
            delete geometry.indices;
            sharedBoxGeometry.triangulated = true;
        }
        this.boxMesh.geometry = sharedBoxGeometry
        this.boxMesh.material = sharedBoxProgram
        this.boxMesh.position[2] = 0;
        this.boxMesh.updateMatrix()
        this.boxMesh.updateWorldMatrix()
        container.add(this.boxMesh);

        this.container = container;

        this.lastRes = [BLUR_RES , BLUR_RES];
        this.currRes = !USE_MIPMAP ? [BLUR_RES , BLUR_RES] : [BLUR_RES / 2, BLUR_RES / 2];

    }   
    connectedCallback() {

    }
    disconnectedCallback() {
        this.video?.removeEventListener('play',  this.onVideoPlay);
        this.video?.removeEventListener('pause', this.onVideoPause);
    }
    onVideoPlay() {
        this.screenTexture.loaded = true;
        this._isPlaying = true;
    }
    onVideoPause() {
        this._isPlaying = false;
    }
    play() {
        !this._isPlaying && this.video?.play();
    }
    pause() {
        this._isPlaying && this.video?.pause();
    }
    
    updateBox( bufferScene, bufferPlane, bufferCamera) {
        
        this.lastDate = this.lastDate || Date.now();

        if (this.video && Date.now() - this.lastDate > 1000 / VIDEO_FPS && this._isPlaying ) {
            if (this.screenTexture.loaded) {
                if (this.fitViewport) {
                    const { offsetX,  offsetY,  width,  height} = cover(window.innerWidth, window.innerHeight, this.video.width, this.video.height);
                    this.ctx.drawImage(this.video, offsetX, offsetY, width, height);
                }
                this.screenTexture.bindImage(this.fitViewport ? this.canvas : this.video);
            }
            if (this.hasRenderedBlur) {
                this.rendferedBluredFrame = 0;
                this.hasRenderedBlur = false;
            }
            this.needsBlurUpdate = true;
            this.lastDate = Date.now();
        }
        
        this.planes.forEach(plane => {
            plane.updateMatrix();
            plane.updateWorldMatrix();
            plane.material.setUniform('tInput',         this.blankFrameBuffer);
            plane.material.setUniform('tReflections',   this.blankFrameBuffer);
            plane.material.setUniform('tInput2',        this.blankFrameBuffer);
        });
        

        if (this.screenTexture.height > this.screenTexture.width && !this.skipPortraitScale) {
            this.boxMesh.scale[0] = 2. * (this.screenTexture.width / this.screenTexture.height);
            this.boxMesh.scale[1] = 2.  ;
            this.boxMesh.scale[2] = 1.  ;
        }
        else {
            this.boxMesh.scale[0] = this.screenTexture.width / this.screenTexture.height
            this.boxMesh.scale[1] = 1.  ;
            this.boxMesh.scale[2] = 1.  ;
        }

        this.boxMesh.updateMatrix();
        this.boxMesh.updateWorldMatrix();
        this.boxMesh.material.setUniform('tInput',         this.blankFrameBuffer);
        this.boxMesh.material.setUniform('tReflections',   this.blankFrameBuffer);
        this.boxMesh.material.setUniform('tInput2',        this.blankFrameBuffer);

        // BLUR
        if (this.screenTexture.loaded && (!this.hasRenderedBlur || this.needsBlurUpdate)) {

            this.screenTextureResolution = [this.screenTexture.width, this.screenTexture.height];

            bufferCamera.left =    -REFLECTION_ALTAS_W/2;
            bufferCamera.right =   REFLECTION_ALTAS_W/2;
            bufferCamera.top =     REFLECTION_ATLAS_H/2;
            bufferCamera.bottom =  -REFLECTION_ATLAS_H/2;
            bufferPlane.scale[0] = REFLECTION_ALTAS_W
            bufferPlane.scale[1] = REFLECTION_ATLAS_H
            bufferCamera.updateProjectionMatrix();
            bufferCamera.update();

            bufferPlane.material = this.blurMaterial;

            this.blurMaterial.setUniform('tBlurInput', this.screenTexture);
            // this.blurMaterial.setUniform('uBlurDirection', this.screenTextureResolution);
            this.blurMaterial.setUniform('uBlurResolution', [BLUR_RES, BLUR_RES]);
            this.blurMaterial.setUniform('uLastBlurResolution',[BLUR_RES, BLUR_RES]);
            this.blurMaterial.setUniform('uSourceResolution',  this.screenTextureResolution);//[1562, 934]);
            this.blurMaterial.setUniform('uPass', 0);
            this.renderer.clearColor(0, 0, 0, 0);
            this.renderer.clear();
            this.renderer.render(bufferScene,  bufferCamera, this.blurTexture0);

            if (this.rendferedBluredFrame == 0) {
                this.prev = this.blurTexture0;
                this.lastRes = [BLUR_RES , BLUR_RES];
                this.currRes = !USE_MIPMAP ? [BLUR_RES , BLUR_RES] : [BLUR_RES / 2, BLUR_RES / 2];
            }

            // multiple level of roughness
            if (this.rendferedBluredFrame > 0) {
                const offset = USE_MIPMAP ? 1 : this.rendferedBluredFrame * (1 + 0.04*this.rendferedBluredFrame*this.rendferedBluredFrame);//i * 1.5 ;
                this.blurMaterial.setUniform('uLastBlurResolution',  this.lastRes);
                this.blurMaterial.setUniform('uBlurResolution',      this.currRes);
                this.blurMaterial.setUniform('uBlurDirection', [offset, 0]);
                this.blurMaterial.setUniform('tBlurInput', this.prev);
                this.blurMaterial.setUniform('uPass', 1);
                this.renderer.clearColor(0, 0, 0, 0);
                this.renderer.clear();
                this.renderer.render(bufferScene,  bufferCamera, this['blurTextureTemp' + this.rendferedBluredFrame]);
                this.blurMaterial.setUniform('uBlurDirection', [0, offset]);
                this.blurMaterial.setUniform('tBlurInput',  this['blurTextureTemp' + this.rendferedBluredFrame]);
                this.blurMaterial.setUniform('uPass', 1);
                this.renderer.clearColor(0, 0, 0, 0);
                this.renderer.clear();
                this.renderer.render(bufferScene,  bufferCamera, this['blurTexture' + this.rendferedBluredFrame]);
                this.prev = this['blurTexture' + this.rendferedBluredFrame];
                this.lastRes = !USE_MIPMAP ? [this.lastRes[0] ,this.lastRes[1]] : [this.lastRes[0]/2 ,this.lastRes[1]/2];
                this.currRes = !USE_MIPMAP ? [this.currRes[0] ,this.currRes[1]] : [this.currRes[0]/2 ,this.currRes[1]/2];
            }

            this.hasRenderedBlur = this.rendferedBluredFrame >= 6;
            this.needsBlurUpdate = false;

            this.rendferedBluredFrame++;

        }

        this.container.updateMatrix();
        this.container.updateWorldMatrix();

        this.boxMesh.material.setUniform("uResolution", [ this.resolution[0], this.resolution[1] ]);
        this.boxMesh.material.setUniform('useRT', USE_RT);
        this.frameIndex++;

    }

    resize(w,h) {
        this.resolution[0] = w;
        this.resolution[1] = h;
    }

}
